import { jsx as _jsx } from "react/jsx-runtime";
import React, { lazy, Suspense } from 'react';
const DynamicComponent = ({ loader, loading = _jsx("div", {}) }) => {
    const Component = lazy(loader);
    return (props) => (_jsx(Suspense, { fallback: loading, children: _jsx(Component, { ...props }) }));
};
export default DynamicComponent;
